// @flow

import React, { useEffect, useState } from 'react';
import { Pendency } from '~/screens/ContractDetails/Panels/Pendencies/styled';
import pendencyTitle from '~/typings/enums/PendencyType';
import Selection from './components/Selection';

type DocumentsProps = {
  onEnter: (number: string) => void,
  id?: number,
  type?: string,
  banks: Array<{ name: string, bankNumber: string }>,
};

function Address(props: DocumentsProps) {
  const [showModal, setStateShowModal] = useState(false);
  const setShowModal = (show) => () => {
    setStateShowModal(show);
  };

  const onEnter = (fields) => {
    setShowModal(false)();
    props.onEnter(fields);
  };

  return (
    <>
      <Pendency onClick={setShowModal(true)}>
        {pendencyTitle(props.pendingType) || props.children}
        <span>{props.reason}</span>
      </Pendency>
      <Selection
        {...props}
        banks={props.banks}
        showModal={showModal}
        onModalClose={setShowModal(false)}
        onSend={onEnter}
      />
    </>
  );
}

export default Address;
